__turbopack_context__.v({
  "icon": "Lkv80a_icon",
});
